import { render, staticRenderFns } from "./WorkOrderPriceTab.vue?vue&type=template&id=6bcba897&scoped=true&"
import script from "./WorkOrderPriceTab.vue?vue&type=script&lang=ts&"
export * from "./WorkOrderPriceTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcba897",
  null
  
)

export default component.exports